import { defaultHttpClient } from '../../httpClient';
import type {
  GetMarketHomeGoodsRequestParams,
  GetMarketHomeGoodsResponse,
} from './types';

export const getMarketHomeGoods = (
  marketId: number,
  params: GetMarketHomeGoodsRequestParams,
) => {
  return defaultHttpClient
    .request<GetMarketHomeGoodsResponse>({
      url: `/api/v2/markets/${marketId}/home_goods/`,
      method: 'GET',
      params,
    })
    .then(result => result.data);
};
